<script>
export default {
	data() {
		return {
			isLoaded: false
		};
	},

	created() {
		this.addLoadListener();
	},

	beforeUnmount() {
		this.removeLoadListener();
	},

	methods: {
		addLoadListener() {
			window.addEventListener('load', this.changeLoad);
		},

		removeLoadListener() {
			window.removeEventListener('load', this.changeLoad);
		},

		changeLoad() {
			this.isLoaded = true;
		}
	}
};
</script>
